export class Txt {
  id: number;
  text: string | string[];
  description: string;
}

export class TxtList {
  [key: string]: Txt;
}
